import { GridColDef } from "@mui/x-data-grid";

// Columns for the DataGrid
const clientColumnDef: GridColDef[] = [
    { field: 'client_name', headerName: 'Client Name', width: 200 },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'client_contact', headerName: 'Client Contact', width: 200 },
    { field: 'client_address', headerName: 'Client Address', width: 200 },
    { field: 'is_active', headerName: 'Status', width: 50 },
    { field: 'created_date', headerName: 'Created Date', width: 200 },
    { field: 'created_by', headerName: 'Created By', width: 200 }
];

export default clientColumnDef;